export default __webpack_public_path__ + "stroke-width-3.asset.f9c3d42c8d9a438e5a4258335dadd819.svg";